"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ApexChartContainer = _interopRequireDefault(require("./ApexChartContainer"));
var _TVChartContainer = _interopRequireDefault(require("./TVChartContainer"));
var _LightWeightChartContainer = _interopRequireDefault(require("../LightWeightCharts/LightWeightChartContainer"));
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var chartOptions = {
  APEX: /*#__PURE__*/_react["default"].createElement(_ApexChartContainer["default"], null),
  TradingView: /*#__PURE__*/_react["default"].createElement(_TVChartContainer["default"], null),
  LightWeight: /*#__PURE__*/_react["default"].createElement(_LightWeightChartContainer["default"], null)
};
var PriceChartContainer = function PriceChartContainer(props) {
  var chart = _config["default"].TradingLayout.chart;
  if (props.chart) chart = props.chart;
  return chartOptions[chart];
};
var _default = exports["default"] = PriceChartContainer;